/* Targeted corrections for theme controls and dynamically rendered Reviews.io markup. */
(()=>{'use strict';
function reviewFix(root){
 root.querySelectorAll('.R-LabelTag--shopVerified[aria-label]').forEach(el=>{if(el.getAttribute('role')!=='img')el.setAttribute('role','img');});
 root.querySelectorAll('.R-PaginationControls__item[role="button"]').forEach(el=>{
  const text=el.textContent.trim();if(!/^\d+$/.test(text))return;
  const label='Page '+text;if(el.getAttribute('aria-label')!==label)el.setAttribute('aria-label',label);
  if(el.classList.contains('isActive'))el.setAttribute('aria-current','page');else el.removeAttribute('aria-current');
 });
}
function init(){
 document.querySelectorAll('hover-disclosure').forEach(el=>{
  if(el.dataset.rgbKeyboard)return;el.dataset.rgbKeyboard='true';
  el.addEventListener('keydown',e=>{const link=el.querySelector('[data-top-link]');
   if(e.key==='Escape'){e.preventDefault();link.focus();el.dispatchEvent(new CustomEvent('theme:disclosure:hide'));}
   if(e.key==='ArrowDown'&&e.target===link){e.preventDefault();el.dispatchEvent(new CustomEvent('theme:disclosure:show'));el.querySelector('.header__dropdown a')?.focus();}
  });
 });
 document.querySelectorAll('.product-link').forEach(link=>{
  if(link.dataset.rgbKeyboard)return;link.dataset.rgbKeyboard='true';
  link.addEventListener('keydown',e=>{if(!['ArrowLeft','ArrowRight'].includes(e.key))return;const slider=link.querySelector('[data-hover-slider]');if(!slider||slider.scrollWidth<=slider.clientWidth)return;e.preventDefault();slider.scrollBy({left:(e.key==='ArrowRight'?1:-1)*slider.clientWidth,behavior:'instant'});});
 });
 document.querySelectorAll('hover-images[aria-hidden="true"]').forEach(preview=>{
  if(preview.dataset.rgbA11y)return;preview.dataset.rgbA11y='true';
  const untab=()=>preview.querySelectorAll('button,[tabindex],a,video[controls]').forEach(el=>{if(el.getAttribute('tabindex')!=='-1')el.setAttribute('tabindex','-1');});
  untab();new MutationObserver(untab).observe(preview,{childList:true,subtree:true,attributes:true,attributeFilter:['tabindex']});
 });
 document.querySelectorAll('[data-rgb-photo-step]').forEach(button=>{
  if(button.dataset.rgbA11y)return;button.dataset.rgbA11y='true';
  button.addEventListener('click',()=>{
   const area=button.closest('.product-item__image'),preview=area.querySelector('hover-images'),slider=preview?.querySelector('[data-hover-slider]');if(!slider)return;
   const step=Number(button.dataset.rgbPhotoStep);let index;
   if(preview.flkty?.isActive){step>0?preview.flkty.next():preview.flkty.previous();index=preview.flkty.selectedIndex;}
   else{index=Math.max(0,Math.min(slider.children.length-1,Math.round(slider.scrollLeft/slider.clientWidth)+step));slider.scrollTo({left:index*slider.clientWidth,behavior:'instant'});}
   const image=preview.querySelectorAll('img')[index];area.querySelector('[data-rgb-photo-status]').textContent='Image '+(index+1)+(image?.alt?': '+image.alt:'');
  });
 });
 reviewFix(document);
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
document.addEventListener('shopify:section:load',init);
// Observe inserted app content, batching work; no attribute observation or feedback loops.
let timer;new MutationObserver(records=>{if(!records.some(r=>r.addedNodes.length))return;clearTimeout(timer);timer=setTimeout(init,150);}).observe(document.documentElement,{childList:true,subtree:true});
})();
